import React, { useEffect } from "react";
import WOW from "wowjs";

function Courses() {

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const courses = [
    {
      title: "Digital SAT",
      desc: "Complete preparation aligned with the new adaptive digital SAT format.",
      delay: ".2s",
    },
    {
      title: "PSAT",
      desc: "Foundation-focused preparation to build confidence and early excellence.",
      delay: ".3s",
    },
    {
      title: "ACT",
      desc: "English, Math, Science — strategy-driven tutoring for high composite scores.",
      delay: ".4s",
    },
    {
      title: "AP Test Prep",
      desc: "AP Precalculus, AP Calculus AB & BC, AP Statistics, AP Computer Science, AP Physics, AP Chemistry",
      delay: ".5s",
    },
    {
      title: "GCSE & IGCSE Tutoring",
      desc: "Math, English, Physics, Chemistry, Biology, Social Studies",
      delay: ".6s",
    },
    {
      title: "AS & A Levels",
      desc: "Math, Chemistry, Physics, Biology",
      delay: ".7s",
    },
    {
      title: "US High School Tutoring",
      desc: "Algebra I, Algebra II, Calculus, Chemistry, Physics, Statistics",
      delay: ".8s",
    },
  ];

  return (
    <section
      id="courses"
      className="courses-rail pt-100 pb-100"
    >

      <div className="container">

        <div className="courses-row">

          {/* LEFT IMAGE */}
          <div
            className="courses-image wow fadeInLeft"
            data-wow-delay=".2s"
          >
            <img src="/assets/img/courses/courses-left-image.avif" alt="Courses Illustration" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="courses-content">

            <h2
              className="wow fadeInUp"
              data-wow-delay=".2s"
            >
              Our Courses
            </h2>

            <p
              className="courses-sub wow fadeInUp"
              data-wow-delay=".3s"
            >
              Expert-led preparation across global curricula
            </p>

            <div className="course-list">

              {courses.map((course, index) => (
                <div
                  key={index}
                  className="course-item wow fadeInUp"
                  data-wow-delay={course.delay}
                >
                  <span className="course-dot"></span>

                  <div>
                    <h3>{course.title}</h3>
                    <p>{course.desc}</p>
                  </div>
                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

    </section>
  );
}

export default Courses;
